import arrayLikeToArray from "./arrayLikeToArray";
export default function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/arrayWithoutHoles.js
// module id = 743
// module chunks = 0